



































import { UiProgressLinear } from '../keen-ui';

import DataTableRow from './data-table-row.component.vue';

export default {
  name: 'data-table',
  components: {
    DataTableRow,
    UiProgressLinear
  },
  computed: {
    allDataItemsAreSelected: function (): boolean {
      return (!!this.selection.length && (this.selection.length === this.data.length));
    },
    rowProps: function () {
      return {
        columns: this.columns,
        sort: this.sort,
        selectEnabled: this.selectEnabled,
        multiselectEnabled: this.multiselectEnabled,
        allDataItemsAreSelected: this.allDataItemsAreSelected,
        selection: this.selection,
        selectionCheckboxesHidden: this.selectionCheckboxesHidden,
        hasChildren: this.getLeveledData(this.data).some(dataItem => !!dataItem.children),
        multiChildrenExpandEnabled: this.multiChildrenExpandEnabled,
        expandedChildrenIds: this.expandedChildrenIds,
        rowsIdField: this.rowsIdField
      };
    }
  },
  props: {
    columns: Array,
    data: Array,
    sort: Object,
    selectEnabled: Boolean,
    multiselectEnabled: Boolean,
    selection: {
      type: Array,
      default: () => []
    },
    selectionCheckboxesHidden: Boolean,
    expandedChildrenIds: {
      type: Array,
      default: () => []
    },
    multiChildrenExpandEnabled: Boolean,
    headerHidden: Boolean,
    rowsIdField: {
      type: String,
      default: 'id'
    },
    loading: Boolean
  },
  methods: {
    getLeveledData: function (data: any[], level = 0): any[] {
      data.forEach((dataItem: any) => {
        dataItem.level = level;
        if (!!dataItem.children && !!dataItem.children.length) {
          this.getLeveledData(dataItem.children, level + 1);
        }
      });
      return data;
    },
    onExpandedChildrenChange: function (dataItemIds: string[]): void {
      this.$emit('update:expandedChildrenIds', dataItemIds);
    },
    onSelectAllChange: function (selectAll: boolean): void {
      const selection = (selectAll ? this.data.slice() : []);
      this.$emit('selectionChange', selection);
    },
    resetScroll: function (): void {
      this.$refs.content.scrollTop = 0;
    }
  },
  watch: {
    data: function (data: any[]): void {
      const selection = this.selection.filter(
        (selectedItem: any) => data.some((dataItem: any) => (dataItem[this.rowsIdField] === selectedItem[this.rowsIdField])));
      if (selection.length !== this.selection.length) {
        this.$emit('selectionChange', selection);
      }
    }
  }
};

